import type { MessageInstance } from 'antd/es/message/interface'

export interface MessageStyles {
  notice: string
  small: string
  iconInfo: string
  iconSuccess: string
  iconError: string
  iconWarning: string
  iconLoading: string
  body: string
  bodySmall: string
  text: string
  title: string
  titleSmall: string
  description: string
  descriptionSmall: string
  close: string
}

interface MessageBridge {
  message: MessageInstance
  styles: MessageStyles
}

let bridge: MessageBridge | null = null

export const registerMessageBridge = (value: MessageBridge): void => {
  bridge = value
}

export const getMessageBridge = (): MessageBridge | null => bridge
